// extracted by mini-css-extract-plugin
export default {"Loading":"Loading_Loading__4p7J8","loadingIcon":"Loading_loadingIcon__p+dTh","load":"Loading_load__qM4iq"};